/**
 * ユーザー
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'
import * as types from '../../../mutation-types/driver-types'
import {DRIVER_USER_RESET_PAGINATION} from "../../../mutation-types/driver-types";
const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/users`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      limit: 50,
      name: null,
      role: null,
      without_invisible: true,
    },
  }
}
const user = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * ユーザー一覧取得
     * @param dispatch
     * @param commit
     * @param state
     * @param name
     * @param role
     * @param without_invisible
     * @param page
     * @param limit
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { name, role, without_invisible, page, limit, format }) {
      const api_path = format === 'csv' ? `${API_PATH}.csv` : `${API_PATH}`
      dispatch('saveCondition', { name: name, role: role, limit: limit, without_invisible: without_invisible })
      const params = { name: state.condition.name, role: state.condition.role, without_invisible: state.condition.without_invisible, page: page, limit: limit }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          if (format != 'csv') {
            let content = data.content
            commit(types.DRIVER_USER, { content }) 
            resolve(content)
          } else {
            resolve(data)
          }
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params, { headers: { 'Content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })

    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params, { headers: { 'Content-type': 'multipart/form-data'}}).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    /**
     * 登録ユーザのテナント内の件数(法人管理者、サポートを除く)取得
     * お試しプランの件数チェック用に検索条件を無視して件数を取得する
     * @param commit
     * @return {Promise<unknown>}
     */
    check ({ commit }) {
      const params = {}
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    sendInvitationMail( { commit, state }, { id } ) {
      const api_path = `${API_PATH}/${id}/send_mail`
      return new Promise( ( resolve, _reject ) => {
          Vue.$http.put(api_path).then( data => {
              let content = data.content
              commit('snackbar/showInfo', { message: '送信しました' }, { root: true })
              resolve(content)
          } )
      })
    },
    sendInvitationSms( { commit, state }, { id } ) {
      const api_path = `${API_PATH}/${id}/send_sms`
      return new Promise( ( resolve, _reject ) => {
          Vue.$http.put(api_path).then( data => {
              let content = data.content
              commit('snackbar/showInfo', { message: '送信しました' }, { root: true })
              resolve(content)
          } )
      })
    },
    saveCondition ({ commit, state }, { name, role, limit , without_invisible }) {
      const _name = (name !== undefined) ? name : state.condition.name
      const _role = (role !== undefined) ? role : state.condition.role
      const _without_invisible = (without_invisible !== undefined) ? without_invisible : state.condition.without_invisible
      const _limit = (limit !== undefined) ? limit : state.condition.limit
      const params = { name: _name, role: _role, limit: _limit, without_invisible: _without_invisible }
      commit(types.DRIVER_USER_CONDITION, { params })
    },
    resetState ({ commit, state}) {
      commit(types.DRIVER_USER_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.DRIVER_USER_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.DRIVER_USER_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_USER_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.DRIVER_USER] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_USER_CONDITION] (state, { params }) {
      state.condition.name = params.name
      state.condition.role = params.role
      state.condition.limit = params.limit
      state.condition.without_invisible = params.without_invisible
    }
  },
}

export default user

